import { SuretyAccountId } from "@inrev/common";
import { useFetchAccountCompanies, useFetchSuretyAccount } from "@portal/api/account";
import { LoadingModal } from "@portal/components/layout/LoadingModal";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AccountLayout } from "../../account/AccountLayout";
import { useAccountTabsNavigation } from "../../account/useAccountTabNavigation";
import { AccountBondsTab } from "./AccountBondsTab";
import { AccountDetailsTab } from "./AccountDetailsTab/AccountDetailsTab";
import { AccountFinancialsWithAdjustmentsTab } from "./AccountFinancialsWithAdjustmentsTab";
import { AccountIndemnityTab } from "./AccountIndemnityTab";
import { AccountOverviewTab } from "./AccountOverviewTab/AccountOverviewTab";
import { AccountWIPTab } from "./AccountWIPTab";

export const SuretyAccountView = () => {
	const { id } = useParams();
	const navigateTabs = useAccountTabsNavigation();

	const accountId = id as SuretyAccountId;
	const { suretyAccount, suretyAccountIsLoading, suretyAccountError } =
		useFetchSuretyAccount(accountId);
	const { companies } = useFetchAccountCompanies(accountId);
	const [searchParams] = useSearchParams();
	const activeTabId = useMemo(() => searchParams.get("t"), [searchParams]);
	const navigate = useNavigate();

	useEffect(() => {
		if (!activeTabId) navigateTabs({ tabId: "overview" }, { replace: true });
	}, []);

	useEffect(() => {
		if (suretyAccountError) {
			navigate("/accounts");
		}
	}, [suretyAccountError]);

	if (suretyAccountIsLoading || suretyAccount === undefined) {
		return <LoadingModal />;
	}

	return (
		<AccountLayout
			account={suretyAccount}
			companies={companies}
			tabs={[
				{
					id: "overview",
					label: "Overview",
					Component: AccountOverviewTab,
					isDefault: activeTabId === null || activeTabId === "overview",
				},
				{
					id: "details",
					label: "Details",
					Component: AccountDetailsTab,
					isDefault: activeTabId === "details",
				},
				{
					id: "financials",
					label: "Financials",
					Component: AccountFinancialsWithAdjustmentsTab,
					isDefault: activeTabId === "financials",
					expanded: true,
					viewport: true,
				},
				{
					id: "wip",
					label: "WIP",
					Component: AccountWIPTab,
					isDefault: activeTabId === "wip",
				},
				{
					id: "indemnity",
					label: "Indemnity",
					Component: AccountIndemnityTab,
					isDefault: activeTabId === "indemnity",
				},
				{
					id: "bonds",
					label: "Bonds",
					Component: AccountBondsTab,
					isDefault: activeTabId === "bonds",
					expanded: true,
				},
			]}
		/>
	);
};
